import { LocalStorageService } from './../../../../core/services/local-storage.service';
import { EsnAppeloffreService } from './../../../../core/services/esn-appeloffre/esn-appeloffre.service';
import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { environment } from './../../../../../environment/environment';
import Swal from 'sweetalert2';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { NgxSpinnerService } from 'ngx-spinner';


@Component({
  selector: 'app-detailcandidaturecalloffer',
  templateUrl: './detailcandidaturecalloffer.component.html',
  styleUrls: ['./detailcandidaturecalloffer.component.css'],
})
export class DetailcandidaturecallofferComponent {
  /* number */
  tabulation: number = 10;
  /* boolean */
  disabledMode: boolean = true;
  url: string = environment.baseUrl + '/api';
  /* object */
  jobofferDetails: any;
  itemsPerPage: number = 5;
  currentPage: number = 1;
  currentSortDirection: number = 2;
  startIndex: number = 0;
  endIndex: number = 5;
  totalItems!: number;
  listcandidature: any;
  /* string */
  idEsn!: string;
  nameEsn = this.localStorageService.getData('clientConnectedName');
  idclientConnected = this.localStorageService.getData('clientConnected');
  colorsHeader: string[] = [
    '#FBF2E9',
    '#E8F6FC',
    '#FDEFEE',
    '#FFF3D7',
    '#FBF2E9',
  ];
  /* formGroup */
  id = this.activatedRoute.snapshot.params['id'];
  userid = this.activatedRoute.snapshot.params['userid'];

  iduser: any;
  listconsultant: any;
  sortAttr: string = '';
  user_id:any;
  urlimage: string = environment.baseUrlGalery;
  selectedUserId!: string;
  safeDescription!: SafeHtml;
  skills: any;
  constructor(
    private activatedRoute: ActivatedRoute,
    private appelofferservice: EsnAppeloffreService,
    private toastrService: ToastrService,
    private route: Router,
    private localStorageService: LocalStorageService,
    private sanitizer: DomSanitizer,
    private spinner: NgxSpinnerService
  ) {}
  ngOnInit() {
    window.scrollTo(0, 0);
    this.getjobofferById();
    this.getlistcandidature();
    this.getskillsjobrequest();
  }
  getlistcandidature() {
    this.spinner.show();
    let dataPyload =
      this.sortAttr == ''
        ? {
            company_id: this.idclientConnected,
            per_page: this.itemsPerPage,
            page: this.currentPage,
          }
        : {
            company_id: this.idclientConnected,
            per_page: this.itemsPerPage,
            page: this.currentPage,
            sort: this.currentSortDirection,
            sortAttribute: this.sortAttr,
          };
    this.appelofferservice.getlistcandidature(dataPyload).subscribe({
      next: (response: any) => {
        if (response.data && response.data.data) {
          console.log('response.data', response.data);
          this.listcandidature = response.data.data
          // this.user_id=response?.data?.data[0].consultant_id
          console.log("user_id",this.user_id)
         
          // .slice(0, this.endIndex);
          this.totalItems = response.data.total;
          this.spinner.hide();
    
          console.log('list candidature', this.listcandidature);
        }
      },
      error: (error: any) => {
        console.error('Error fetching candidature: ', error);
        this.spinner.hide();
      },
    });
  }
  /* get job offer details */
  getjobofferById() {
    this.spinner.show();
 
    this.appelofferservice.getcallByIdcandidature(this.id,this.userid).subscribe({
      next: (res: any) => {
        console.log('reponse', res);
        this.jobofferDetails = res.data[0];
        this.updateDescription(this.jobofferDetails?.job_request?.description);
        console.log('detail job offer', this.jobofferDetails);
        this.spinner.hide();
      },
      error: () => {},
    });
  } 
  updateDescription(description: string) {
    this.safeDescription = this.sanitizer.bypassSecurityTrustHtml(description);
  }

  /* get skills job request  */
  getskillsjobrequest() {
    this.appelofferservice.getskillsappeloffre(this.id).subscribe({
      next: (res: any) => {
        this.skills = res.data;
        console.log('skills job request', this.skills);
      },
      error: (error) => {
        console.log('error', error);
      },
    });
  }

  retirercandidature() {
    let data = {
      company_id: this.idclientConnected,
      user_id: this.jobofferDetails.User_id,
      job_request_id: this.jobofferDetails.id,
    };
    console.log('data', data);
    Swal.fire({
      title: 'Êtes-vous sûr de vouloir retirer cette candidature ?',

      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085D6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Oui, retirer !',
      cancelButtonText: 'Annuler',
    }).then((result) => {
      if (result.isConfirmed) {
        this.appelofferservice.retirercandidature(data).subscribe({
          next: (res: any) => {
            console.log('res', res);
            this.toastrService.success(
              'votre candidature a été retiré avec succès.'
            );
            this.route.navigateByUrl('/offres-appel/candidature');
          },
          error: (error) => {
            console.log(error);
            console.log(error.error.message);
            if (error.error.message === 'candidature already exist.') {
              this.toastrService.error('Candidature existe déjà');
            }
            if (error.error.message === 'the job offer has been deactivated.') {
              this.toastrService.error(
                "La postulation n'est pas autorisée car l'appel d'offres est désactivé."
              );
            }
          },
        });
      }
    });
  }
}
